export function extendSession() {
    try {
        if (window.topicPublisher) {
            window.topicPublisher.publish("/tricare/core/sessionExtend");
        } else {
            console.warn("failed to extend session, no window.topicPublisher");
        }
    } catch (error) {
        console.warn("failed to extend session", error);
    }
}